import type { TeamPerson } from './api'

/**
 * A person's logged time today, kept moving between refreshes.
 *
 * The server's number is a snapshot; for someone who is timing right now it grows by however
 * long ago the snapshot was taken, so the clock on screen never sits still for the fifteen
 * seconds between refreshes. Nobody else's number moves.
 */
export function liveTodayMs(person: Pick<TeamPerson, 'working' | 'todayMs'>, fetchedAt: number, clientNow: number): number {
  return person.todayMs + (person.working ? Math.max(0, clientNow - fetchedAt) : 0)
}

/** 0–1 toward a time target, or null when there is no time target to measure against. */
export function targetProgress(todayMs: number, targetMinutes: number | null | undefined): number | null {
  if (!targetMinutes || targetMinutes <= 0) return null
  return Math.min(1, todayMs / (targetMinutes * 60_000))
}

/** "3h" , "1h 30m", "45m": a target, written the way people say it. */
export function formatTargetMinutes(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m}m`
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}
